import type { IconProps } from '.';

/**
 * Close Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const CloseIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <rect x="6" y="17.3137" width="16" height="1" transform="rotate(-45 6 17.3137)" fill="white" />
    <rect x="6.70703" y="6" width="16" height="1" transform="rotate(45 6.70703 6)" fill="white" />
  </svg>
);

export default CloseIcon;
